<template>
    <section class="section pt-5 pb-5">
        <div class="container position-relative">
            <div class="mb-5">
                <div class="conatiner-logo-general">

                    <router-link to="/"><img src="@/assets/talento_agv/img/AV_Logo_NEW_Purple_RGB_800.png" alt="" srcset=""></router-link>
                </div>

                <h3 class="header-title text-center agv-text">{{ $t('Nuestra') }} <span
                        class="bg-green">{{ $t('Cultura') }}</span>
                </h3>
                <!-- <hr class="separador-title"> -->
                <h4 class="link-cultura" style="font-size:20px; color: #000;"><router-link to="/"
                        class="item-link-cultura">{{ $t('Inicio') }}</router-link> /
                        {{ $t('Nuestra Cultura') }}</h4>
            </div>

            <div class="carousel-cultura mb-5" @mousemove="moveCircle">
                <Carousel class="mt-5 " :itemsToShow="toShow" :wrapAround="true" :transition="500">
                    <Slide v-for="item in dataTableAttributes" :key="item.id">
                        <div class="blog-container mx-2">
                            <div class="blog-image-poster">
                                <img :src="item.s3_url" alt="">
                                <div class="blog-article-content">
                                    <h6 class="name-employee">{{ item.description }}</h6>
                                </div>
                            </div>
                        </div>
                    </Slide>
                </Carousel>
                <div class="cursor-circle" :style="{ top: `${mauseY - 100}px`, left: `${mauseX - 100}px` }">
                    <span>Deslizar</span>
                </div>
            </div>
        </div>
    </section>

    <!-- Nuestro Lideres -->
    <section class="section pt-5 pb-5 company-hire nuestros_lideres" style="position:relative">
        <div class="container">
            <h3 class="header-title text-center mb-5 text-white">{{ $t('Nuestros Líderes') }}
            </h3>
            <div id="trust-company-slider" class="owl-carousel owl-theme trust-slider developers-slider">
                <Carousel :autoplay="3000" :loop="true" :wrap-around="true" :settings="settings"
                    :breakpoints="breakpoints">
                    <Slide class="company-logos" v-for="item in dataTableLeaders" :key="item.id">

                        <!-- <img  :src="item.s3_url" alt="Img"> -->
                        <div class="lideres">
                            <ul>
                                <li :key="item.id" class="text-center">
                                    <img :src="item.s3_url" alt="img_agv_lider" class="mb-3">
                                    <span class="text-white"><strong>{{ item.name }}</strong></span><br>
                                    <span class="text-white" style="display: block; height: 50px;">{{ item.work_position }}</span>
                                </li>
                            </ul>
                        </div>

                    </Slide>
                </Carousel>
            </div>
        </div>
    </section>

    <!-- Yo elijo trabajar en Agrovision -->
    <section class="section review yo_elijo_trabajar_agv" style="position:relative">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-sm-12 col-md-9">
                    <h3 class="header-title text-center">{{ $t('Yo eljo trabajar en') }} <span class="bg-sky-blue">Agrovision</span></h3>
                    <!-- <hr class="separador mb-5 w-50 bg-sky-blue"> -->
                    <div class="row mb-5 mt-5" v-for="(item, index) in dataTableTestimonials" :key="item.id">
                        <div :class="index % 2 === 0 ? 'col-lg-6 pt-4' : 'col-lg-6 order-lg-last pt-4'">
                            <div >
                                <div class="demand-professional">
                                    <p v-html="item.text"></p>
                                </div>
                            </div>
                        </div>
                        <div :class="index % 2 === 0 ? 'col-lg-6' : 'col-lg-6 order-lg-first'">
                            <div style="padding:56.25% 0 0 0;position:relative;width:100%;">
                                <iframe :src="`${item.video}&title=0&byline=0&portrait=0`" frameborder="0"
                                    allow="autoplay; picture-in-picture; clipboard-write; fullscreen" style="position:absolute;top:0;left:0;width:100%;height:100%;
                                ">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Crear Cuenta-->
    <section class="section job-register">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="register-job-blk">
                        <div class="job-content-blk" >
                            <h2>Sé el primero en recibir nuestras ofertas laborales</h2>
                            <p>Crea una cuenta y encuentra el trabajo que buscas.</p>
                            
                            <router-link to="/crear_cuenta" class="btn all-btn">Crear Cuenta</router-link>
                            <router-link to="/login" class="btn all-btn">Ingresar</router-link>
                        </div>
                        <div class="see-all mt-0 opportunity">
                            <img src="@/assets/img/opportunity.png" alt="img">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!-- Redes Sociales
    <section class="section mb-5">
        <div class="container pb-5">
            <div class="redes_sociales text-center">
                <h3 class="pt-5 mb-5 text-white">Síguenos en:</h3>
                <ul style="display:flex; justify-content:center; flex-wrap: wrap;">
                    <li><a href="https://www.linkedin.com/company/agrovisionperu/mycompany/" target="_blank"><img
                                src="@/assets/talento_agv/img/redes_sociales/linkedin_logo.png" alt=""
                                style="width:200px; margin: 0 15px"></a></li>
                    <li><a href="https://www.facebook.com/TrabajaEnAgrovisionPeru" target="_blank"><img
                                src="@/assets/talento_agv/img/redes_sociales/facebook_logo.png" alt=""
                                style="width:200px; margin: 0 15px"></a></li>
                    <li><a href="https://www.tiktok.com/@agrovision.peru" target="_blank"><img
                                src="@/assets/talento_agv/img/redes_sociales/tiktok_logo.png" alt=""
                                style="width:200px; margin: 0 15px"></a></li>
                </ul>
            </div>
        </div>
    </section> -->

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>
<script>
import axiosIns from '@/plugins/axios.js';
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
export default {
    data() {
        return {
            toShow: 3,
            mauseX: 0,
            mauseY: 0,
            agvLeaders: [
                {
                    "title": "Bertha Gonzales",
                    "img": "Bertha-Gonzales.png",
                    "position": "Gerente"
                },
                {
                    "title": "Diego Zegarra",
                    "img": "Diego Zegarra.png",
                    "position": "Gerente"
                },
                {
                    "title": "Eduardo Aza",
                    "img": "Eduardo Aza.png",
                    "position": "Gerente"
                },
                {
                    "title": "John Early",
                    "img": "John-Early.jpg",
                    "position": "Gerente"
                },
                {
                    "title": "Enrique Gallo",
                    "img": "Enrique Gallo.png",
                    "position": "Gerente"
                },
                {
                    "title": "Lucas Zecevic",
                    "img": "Lucas Zecevic.jpg",
                    "position": "Gerente"
                },
                {
                    "title": "Renato-Nassi",
                    "img": "Renato-Nassi.jpg",
                    "position": "Gerente"
                },
                {
                    "title": "Oscar Samatelo",
                    "img": "Oscar Samatelo.png",
                    "position": "Gerente"
                },
            ],
            imgsGallery: [
                {
                    "title": "Descripcion 1",
                    "img": "1.jpg",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Descripcion2",
                    "img": "2.jpg",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Descripcion 3",
                    "img": "3.jpg",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Descripcion 4",
                    "img": "4.jpg",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Descripcion 5",
                    "img": "6.jpg",
                    // "subtitle" : "Hola"
                },
            ],
            ourContributors: [
                {
                    "title": "Descripcion 1",
                    "img": "Hebert Custodio - Adminitración.jpg",
                    "text": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
                },
                {
                    "title": "Descripcion2",
                    "img": "Jasmin Bravo -Comex.jpg",
                    "text": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
                },
                {
                    "title": "Descripcion2",
                    "img": "Javier Limo.jpg",
                    "text": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
                },
                {
                    "title": "Descripcion2",
                    "img": "Tania Martinez - Comex.jpg",
                    "text": "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos fugit libero, assumenda nobis fugiat non laboriosam voluptates culpa rem, nesciunt obcaecati, nulla similique in. Consequatur corrupti et ipsa sapiente perspiciatis."
                },
            ],
            brandAttributes: [
                {
                    "title": "Somos una empresa exitosa",
                    "img": "at1.png",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Somos líderes en innovación",
                    "img": "at2.png",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Ofrecemos buenas condiciones laborales",
                    "img": "at3.jpg",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Somos un buen lugar para trabajar",
                    "img": "at4.jpg",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Cultura única",
                    "img": "at5.png",
                    // "subtitle" : "Hola"
                },
                {
                    "title": "Promovemos el liderazgo y trabajo en equipo",
                    "img": "at6.jpg",
                    // "subtitle" : "Hola"
                },
            ],
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 1,
                    snapAlign: "center",
                },
                // 700px and up
                767: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                // 991px and up
                1024: {
                    itemsToShow: 3.5,
                    snapAlign: "center",
                },
                //   // 1024 and up
                //   1024: {
                //     itemsToShow: 4.9,
                //     snapAlign: "start",
                //   },
            },

            dataTableAttributes: [],
            dataTableLeaders: [],
            dataTableGallery: [],
            dataTableTestimonials: [],

            language: null,
        };
    },
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },

    mounted() {
        this.getAttributes()
        this.getLeaders()
        this.getGallery()
        this.getTestimonials()
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },

    methods: {
        moveCircle(event) {
            // Actualizamos las coordenadas X e Y del mouse
            this.mauseX = event.clientX;
            this.mauseY = event.clientY;
        },
        handleResize() {
            // Cambia la cantidad de itemsToShow según el ancho de la pantalla
            if (window.innerWidth < 768) {  // Menos de 768px para dispositivos móviles
                this.toShow = 1;
            } else {
                this.toShow = 3;
            }
        },
        getAttributes() {
            const yo = this
            yo.dataTableAttributes = []
            const config = {
                method: 'get',
                url: '/talentoagv/readAttributes/',
            }

            if (this.$store.getters.currentPublicLanguage == 'es') {
                yo.language = '1'
            }
            else if (this.$store.getters.currentPublicLanguage == 'en') {
                yo.language = '2'
            }

            axiosIns(config)
                .then(function (response) {
                    console.log(response.data['result'])
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        for (let r of resultado) {
                            if (r['key_idioma_id'] == yo.language) {
                                yo.dataTableAttributes.push(r)
                            }
                        }
                        // yo.dataTableAttributes = response.data['result']
                    }
                })
                .catch(function (error) {
                    // console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },

        getLeaders() {
            const yo = this
            // console.log("información del idioma ",yo.language)
            yo.dataTableLeaders = []
            const config = {
                method: 'get',
                url: '/talentoagv/readLeaders/',
            }

            axiosIns(config)
                .then(function (response) {
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        for (let r of resultado) {
                            if (parseInt(r['key_idioma_id']) == parseInt(yo.language)) {
                                yo.dataTableLeaders.push(r)
                            }
                        }
                        console.log("Informacion lista de lideres", yo.dataTableLeaders)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.$toastr.error(error.data['message'], 'Error')
                })
                .finally(function () {

                })
        },

        getGallery() {
            const yo = this
            const config = {
                method: 'get',
                url: '/talentoagv/readGallery/',
            }

            axiosIns(config)
                .then(function (response) {
                    // console.log(response.data['result'])
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        yo.dataTableGallery = response.data['result']
                    }
                })
                .catch(function (error) {
                    // console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },

        getTestimonials() {
            const yo = this
            yo.dataTableTestimonials = []
            const data = JSON.stringify({
                pagina: '2',
                seccion: '14',
            })
            const config = {
                method: 'post',
                url: '/talentoagv/readTestimonials/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            }

            axiosIns(config)
                .then(function (response) {
                    // console.log(response.data['result'])
                    if (response.data['is_error'] === false) {
                        let resultado = response.data['result']
                        for (let r of resultado) {
                            if (r['key_idioma_id'] == yo.language) {
                                yo.dataTableTestimonials.push(r)
                            }
                        }
                        // yo.dataTableTestimonials = response.data['result']
                    }
                })
                .catch(function (error) {
                    // console.log(error);
                    yo.$toastr.error(response.data['message'], 'Error')
                })
                .finally(function () {

                })
        },

    }
};
</script>
<style>
.banner {
    width: 100%;
    height: 280px;
    background-image: url('../../../../assets/img/fondo_principal_inicio.png');
    background-size: contain;
    background-position: center bottom;
}

.banner::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 280px;
    background-color: rgba(0, 0, 0, 0.4);
    /* Color negro semi-transparente */
}

.titulo {
    position: absolute;
    top: 130px;
    left: 50%;
    margin-left: -100px;
    z-index: 5;
}

.descrip_atributo:hover {
    /* position: absolute;
    width: 100%;
    height: 100%; */
    background: none;
    opacity: 0;
    /* Inicialmente oculto */
    display: flex;
    /* justify-content: center;
    align-items: center; */
}

.lideres {
    margin-top: 40px;
    margin-bottom: 20px;
}

.lideres ul {
    display: flex;
    list-style: none;
    flex-wrap: wrap;
    justify-content: center;
}

.lideres ul li {
    width: 180px;
}

.lideres ul li img {
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    background: #fff;
    width: 100%;
    /* border: 4px solid #ffffff; */
    /* border: 4px solid #482775; */
}

@media(max-width:1600px) {
    .vector-rayas {
        height: 60% !important;
    }
}

@media(max-width:1350px) {
    .vector-rayas {
        height: 50% !important;
    }
}

@media(max-width:1200px) {
    .vector-rayas {
        height: 40% !important;
    }
}

@media(max-width:1024px) {
    .vector-rayas {
        height: 35% !important;
    }
}

@media(max-width:991px) {
    .nuestros_lideres .vector_rayas {
        height: 30% !important;
    }

    .yo_elijo_trabajar_agv .vector-rayas {
        height: 20% !important;
    }
}

@media(max-width:768px) {
    .yo_elijo_trabajar_agv .vector-rayas {
        height: 7% !important;
    }
}

@media(max-width:680px) {
    .nuestros_lideres .vector-rayas {
        height: 25% !important;
    }
}

@media(max-width:600px) {
    .nuestros_lideres .vector-rayas {
        height: 20% !important;
    }
}

@media(max-width:480px) {
    .nuestros_lideres .vector-rayas {
        height: 15% !important;
    }

    .titulo_banner {
        width: 400px !important;
        margin-left: -200px !important;
    }
}

@media(max-width:400px) {
    .nuestros_lideres .vector-rayas {
        height: 10% !important;
    }

    .titulo_banner {
        width: 360px !important;
        margin-left: -180px !important;
    }
}
</style>